<template>
  <div class="modal-mask">
    <div :id="modalId" class="modal row" v-on:click.self="closeModal($event)">
      <div class="modal-dialog modal-dialog-md12">
        <div class="modal-content" v-prevent-parent-scroll>
          <div class="modal-header">
            <h3 class="modal-title"><span class="text-muted">{{ $t("KPI") }}</span> {{ kpiData.name }}</h3>
            <div class="pull-right">
              <button data-dismiss="modal" @click="problemModal = !problemModal" type="button" class="btn-rounded btn btn-sm btn-info" aria-hidden="true">
                {{ $t("Report problem") }}
              </button>
              <button v-if="kpiData.can_change_target" data-dismiss="modal" @click="targetModal = !targetModal" v-show="canChangeTarget" type="button" class="btn-rounded btn btn-sm btn-info p-l-15" aria-hidden="true">
                {{ $t("Set target") }}
              </button>
              <button type="button" class="close p-l-20 p-t-5 text-info overrule" @click="closeModal()">
                <i class="ti-close"></i>
              </button>
            </div>
          </div>
          <div class="modal-body ">

            <!-- modals - tab -->
            <ul class="nav nav-tabs">
              <li class="nav-item overrule">
                <a class="nav-link overrule" v-bind:class="{active: activeTab === 'performance'}" v-on:click="activeTab = 'performance'">
                  <span class="hidden-sm-up">
                    <i class="ti-home"></i>
                  </span>
                  <span class="hidden-xs-down">{{ $t("Performance") }}</span>
                </a>
              </li>
              <li class="nav-item overrule">
                <a class="nav-link overrule" v-bind:class="{active: activeTab === 'actions'}" v-on:click="activeTab = 'actions'">
                  <span class="hidden-sm-up">
                    <i class="ti-user"></i>
                  </span>
                  <span class="hidden-xs-down">{{ $t("Actions")}}</span>
                </a>
              </li>
              <li class="nav-item overrule">
                <a class="nav-link overrule" v-bind:class="{active: activeTab === 'problems'}" v-on:click="activeTab = 'problems'">
                  <span class="hidden-sm-up">
                    <i class="ti-email"></i>
                  </span>
                  <span class="hidden-xs-down">{{ $t("Problems")}}</span>
                </a>
              </li>
              <li class="nav-item overrule">
                <a class="nav-link overrule" v-bind:class="{active: activeTab === 'dependencies'}" v-on:click="activeTab = 'dependencies'">
                  <span class="hidden-sm-up">
                    <i class="ti-email"></i>
                  </span>
                  <span class="hidden-xs-down">{{ $t("Dependencies") }}</span>
                </a>
              </li>
            </ul>

            <div class="tab-content container-fluid">
              <div class="tab-pane active show" v-show="activeTab === 'performance'">
                <!-- modals - content tab performance -->
                <div class="row">
                  <div class="col-8 col-md-6 col-sm-0"></div>
                  <div class="col-4 col-md-6 col-sm-12 text-right">
                    {{ $t("Show") }}
                    <select v-if="kpiData.last_performance !== false" class="form-control btn-rounded w-auto time-period-select" v-model="performanceRange.timeunit" @change="period_changed">
                      <option v-for="period in getTimePeriods(kpiData.last_performance.period)" :value="period">{{ $t(ucFirst(period)) }}</option>
                    </select>
                    {{ $t("Period") }}
                    <date-range-picker @update="date_picked" :start-date="performanceRange.start" :end-date="performanceRange.end" opens="left" class="date-range-picker"></date-range-picker>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-3 col-md-4 pull-left p-l-0 p-r-0">
                    <h6 class="m-b-20">{{ $t("Cumulative performance") }}</h6>
                    <h4 class="text-big" v-if="cumulative.performance" v-bind:class="[ Number(cumulative.target_met) === 0 ? 'text-danger' : 'text-success']">
                      {{ cumulative.performance | formatNumber }}

                    </h4>
                    <span v-else class="performance-not-available">{{ $t("Not available") }}</span>
                    <div>
                      <span v-if="Number(cumulative.target) && Number(cumulative.target) !== 0" >/{{ cumulative.target | formatNumber }}</span>
                      <span v-if="Number(cumulative.target) && Number(cumulative.target) !== 0" v-bind:class="[ Number(cumulative.target_met) === 0 ? 'text-danger' : 'text-success']">{{ kpiData.last_performance.unit }}</span>
                      <br class="m-b-20" />
                      <h6 class="text-muted">{{ $t("in period") }} {{ performanceRange.start | formatDate}} {{ $t("till") }} {{ performanceRange.end | formatDate }}</h6>
                    </div>
                  </div>

                  <div class="col-lg-9 col-md-8 pull-right" v-bind:class="{'graph-div': !performanceChartData.loaded}">

                    <chartjs-bar v-if="performanceChartData.loaded"
                                 :option="performanceChartData.options"
                                 :labels="performanceChartData.labels"
                                 :datasets="performanceChartData.dataSets" ref="performanceChart"></chartjs-bar>
                    <div v-if="!performanceChartData.loaded" class="loading-data-div">
                      <img src="../assets/img/loader.gif"> <span>{{ $t("Loading data...") }}</span>
                    </div>
                  </div>

                </div>


                <!-- /modals - content tab performance -->

              </div>

              <!-- tab actions content -->
              <div class="tab-pane active" v-show="activeTab === 'actions'">

                <div class="col-lg-12 col-md-12 p-l-0 p-r-0">
                  <div>
                    <div class="card-body p-t-0 p-l-0 p-r-0">
                      <div class="table-responsive">
                        <table-component :data="fetchActionsData" sort-by="date_end" sort-order="asc"
                                         class="actions-table table-not-searchable"
                                         :filter-no-results="$t('There are no open actions related to this Kpi.')" v-if="dataLoaded">
                          <table-column label="" show="icon" :formatter="iconFormatter" :sortable="false"></table-column>
                          <table-column :label="$t('Action')" show="title"></table-column>
                          <table-column :label="$t('Owner')" :sortable="true" :filterable="true" show="Owner.firstName">
                            <template slot-scope="row">
                              {{ row.Owner.firstname }} {{ row.Owner.lastname }}
                            </template>
                          </table-column>
                          <table-column :label="$t('Due date')" :sortable="true" :filterable="true" show="date_end">
                            <template slot-scope="row">
                              {{ row.date_end | formatDate }}
                            </template>
                          </table-column>
                          <table-column :label="$t('Status')" :sortable="true" :filterable="true" show="status">
                            <template slot-scope="row" sort-by="status">
                              {{ $t(row.status) | ucFirst }}
                            </template>
                          </table-column>

                          <table-column :label="''" :sortable="false" :filterable="false">
                            <template slot-scope="row">
                              <router-link class="overrule" :to="'/action/' + row.uid" data-toggle="modal" :data-target="'#' + modalId" v-if="row.Owner.uid === currentUserId">
                                {{ $t("View") }}
                              </router-link>
                            </template>
                          </table-column>
                        </table-component>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
              <!-- /tab actions content -->

              <!--  tab problem content -->
              <div class="tab-pane active" v-show="activeTab === 'problems'">


                <!-- modals - content problem tab -->
                <!-- list filter -->

                <div class="row justify-content-md-center">
                  <div class="col-12 text-right">
                    {{ $t("Show") }}
                    <select class="form-control btn-rounded w-auto time-period-select"
                            v-model="problemRange.criterium" @change="period_changed">
                      <option value="loss">{{ $t("Loss #") }}</option>
                      <option value="loss_percentage">{{ $t("Loss %") }}</option>
                      <option value="frequency">{{ $t("Frequency") }}</option>
                    </select>
                    {{ $t("Period") }}
                    <date-range-picker @update="date_picked" :start-date="problemRange.start" :end-date="problemRange.end" opens="left" class="date-range-picker"></date-range-picker>
                  </div>
                </div>


                <div class="row">
                  <div class="col-lg-3 pull-left">

                    <h6 class="m-b-15">{{ $t("Problem for period") }}</h6>
                    <h6 class="text-muted" v-if="kpiData.last_performance !== false">{{ $t("in period") }} {{ performanceRange.start | formatDate}} {{ $t("till") }} {{ performanceRange.end | formatDate }}</h6>

                    <h6 class="text-muted m-b-15">{{ $t("Cumulative performance")}}</h6>
                    <h4 class="text-big" v-if="cumulative.performance !== false" v-bind:class="[ cumulative.target_met == '0' ? 'text-danger' : 'text-success']">
                      {{ cumulative.performance | formatNumber }}
                    </h4>
                    <span v-else>
                     {{ $t("Not available") }}
                    </span>
                    <div v-if="cumulative.performance !== false">
                      <span v-if="cumulative.target || cumulative.target === 0">/{{ cumulative.target | formatNumber }}</span>
                      <span v-bind:class="[ cumulative.target_met == '0' ? 'text-danger' : 'text-success']">{{ kpiData.last_performance.unit }}</span>

                    </div>
                  </div>

                  <div class="col-lg-9 pull-right" v-bind:class="{'graph-div': !performanceChartData.loaded}">
                    <chartjs-bar v-if="problemChartData.loaded"
                                 :option="problemChartData.options"
                                 :labels="problemChartData.labels"
                                 :datasets="problemChartData.dataSets"></chartjs-bar>
                    <div v-if="!performanceChartData.loaded" class="loading-data-div">
                      <img src="../assets/img/loader.gif"> <span>{{ $t("Loading data...") }}</span>
                    </div>
                  </div>

                </div>
                <div class="problems-table" v-show="problemData.length > 0">
                  <div class="row table-header">
                    <div class="col-2">
                      <b>{{ $t("Reason")}}</b>
                    </div>
                    <div class="col-1">
                      <b>{{ $t("Loss #")}}</b>
                    </div>
                    <div class="col-1" v-if="kpiData.kpi_unit_financial > 0">
                      <b>{{ $t("Loss $")}}</b>
                    </div>

                    <div class="col-1">
                      <b>{{ $t("Loss %")}}</b>
                    </div>
                    <div class="col-1">
                      <b>{{ $t("Freq.") }}</b>
                    </div>
                    <div class="col-2">
                      <b>{{ $t("Planned")}}</b>
                    </div>
                    <div class="col-1">
                      <b>{{ $t("Actions") }}</b>
                    </div>
                    <div class="col-1">
                      <b>{{ $t("Covered")}}</b>
                    </div>
                    <div class="col-2">
                      <b>{{ $t("Plan") }}</b>
                    </div>
                  </div>

                  <problem-table-row v-if="dataLoaded" v-for="problem in problemData" :problem="problem" :modal-id="modalId" :key="problem.uid"></problem-table-row>
                </div>

                <h3 class="text-muted" v-show="problemData.length < 0">{{ $t("There are no registered problems related to this Kpi.") }}</h3>
              </div>
              <!--  /tab problem content -->

              <!--  tab Dependecies content -->
              <div class="tab-pane active" v-show="activeTab === 'dependencies'">
                <div class="row">
                  <div class="col-8 col-md-6 col-sm-0"></div>
                  <div class="col-4 col-md-6 col-sm-12 text-right">
                    {{ $t("Period") }}
                    <date-range-picker @update="date_picked" :start-date="performanceRange.start" :end-date="performanceRange.end" opens="left" class="date-range-picker"></date-range-picker>
                  </div>
                </div>
                <div v-if="!performanceChartData.loaded" class="loading-data-div">
                  <img src="../assets/img/loader.gif"> <span>{{ $t("Loading data...") }}</span>
                </div>
                <div v-show="relatedKPIData.length > 0 && performanceChartData.loaded">
                  <div class="row">
                    <div class="col-7">
                      {{ $t("Underlying KPI")}}
                    </div>
                    <div class="col-2 header-col">
                      {{ $t("Target")}}
                    </div>
                    <div class="col-2 header-col">
                      {{ $t("Performance") }}
                    </div>
                  </div>
                  <related-kpi-row v-for="relatedKPI in relatedKPIData" :kpiData="relatedKPI" :level="0" :key="relatedKPI.uid"></related-kpi-row>
                </div>
                <h3 class="text-muted" v-show="relatedKPIData.length < 1">{{ $t("This Kpi has no underlying Kpi's.") }}</h3>
              </div>
              <!-- /tab dependecies -->
            </div>
            <!-- /tab content -->
          </div>
          <!-- /modal body -->
        </div>
      </div>

      <report-problem-modal v-if="problemModal" :kpi_units="{'unit':kpiData.last_performance === false ? null : kpiData.last_performance.unit, 'period': kpiData.last_performance === false ? null : kpiData.last_performance.period}" :kpi_name="kpiData.name" :kpi_uid="kpiData.uid" @close="problemModal = !problemModal"></report-problem-modal>
      <set-target-modal v-if="targetModal" :kpi_units="{'unit': kpiData.last_performance === false ? null : kpiData.last_performance.unit, 'period': kpiData.last_performance === false ? null : kpiData.last_performance.period}" :kpi_name="kpiData.name" :kpi_uid="kpiData.uid" :change_able="kpiData.can_change_target" @close="targetModal = false"></set-target-modal>

      <!-- /details - total packacge modals -->
      <kpi-details-modal v-for="related in kpiWidgetModals"
                         v-if="related.open"
                         :kpiId="related.id"
                         :initial-performance-range="performanceRange"
                         :initial-problem-range="problemRange"
                         :key="related.id"/>

    </div>
  </div>
</template>

<script>
  import APIHelper from "../mixins/APIHelper";
  import ReportProblemModal from "./ReportProblemModal";
  import SetTargetModal from "./SetTargetModal";
  import RelatedKpiRow from "./RelatedKpiRow";
  import ProblemTableRow from "./ProblemTableRow";

  export default {
    props: {
      'kpiId': [String, Number],
      'initialPerformanceRange': {
        type: Object,
        default: function() {
          return {
            start: moment().subtract(1, "month"),
            end: moment(),
            timeunit: "week"
          }
        }
      },
      'initialProblemRange': {
        type: Object,
        default: function() {
          return {
            start: moment().subtract(1, "month"),
            end: moment(),
            criterium: "loss"
          }
        }
      }
    },
    name: "KpiDetailsModal",
    components: {
      RelatedKpiRow,
      "report-problem-modal": ReportProblemModal,
      "set-target-modal": SetTargetModal,
      ProblemTableRow
    },
    data: function () {
      return {
        targetModal: false,
        problemModal: false,
        canChangeTarget: false,
        dataLoaded: false,
        calculatedKpi: false,
        currentUserId: localStorage.getItem("user_uid"),
        modalId: "",
        moment: moment,
        performanceRange: this.initialPerformanceRange,
        problemRange: this.initialProblemRange,
        performanceData: {},
        actionData: [],
        actionsPaginationSettings: {
          totalPages:0,
          currentPage: 0
        },
        kpiWidgetModals: [],
        problemData: {},
        relatedKPIData: {},
        kpiData: {
          last_performance: {
            performance: 0
          }
        },
        problemChartData: {
          loaded: false,
          labels: [],
          dataSets: [
            {
              yAxisID: "barAxis"
            }, // The bar data set
            {
              data: [],
              yAxisID: "lineAxis",
              type: "line",
              lineTension: 0,
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderColor: "#2a78e4",
              pointStyle: "circle"
            }
          ],
          options: {
            scales: {
              yAxes: [
                {
                  id: "barAxis",
                  stacked: true,
                  ticks: {
                    beginAtZero: true
                  }
                },
                {
                  id: "lineAxis",
                  ticks: {
                    display: false,
                    beginAtZero: true
                  },
                  gridLines: {
                    display: false
                  }
                }],
              xAxes: [{
                stacked: true
              }]

            },
            responsive: true,
            maintainAspectRatio: true,
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltips: {
              display: false
            }
          }
        },
        relatedKPIIDArray: [],
        performanceChartData: {
          loaded: false,
          labels: [],
          dataSets: [
            { // The target line data
              data: [],
              type: "line",
              lineTension: 0,
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderColor: "#2a78e4",
              pointStyle: "circle"
            },
            // The value data set
            {
              backgroundColor: []
            }
          ],
          options: {
            scales: {
              yAxes: [{
                stacked: true,
                startAtZero: false
              }],
              xAxes: [{
                stacked: true
              }]

            },
            responsive: true,
            maintainAspectRatio: true,
            title: {
              display: false
            },
            legend: {
              display: false
            },
            tooltips: {
              display: false
            }
          }
        },
        cumulative: {},
        activeTab: "performance"
      }
    },
    created(){
      this.loadData(this.kpiId);
      this.modalId = Array(16).join((Math.random().toString(36)+'00000000000000000').slice(2, 18)).slice(0, 16);
    },
    mounted(){

    },
    methods: {
      parseRelatedKpis(related){
        if(typeof related.children === "undefined"){
          this.kpiWidgetModals.push({id: related.uid, open: false});
        }else{
          this.kpiWidgetModals.push({id: related.uid, open: false});
          for(let child in related.children){
            this.parseRelatedKpis(related.children[child]);
          }
        }
      },
      closeModal: function(event) {
        console.log(event);

        // Check if the parent is KpiWidget
        if(this.$parent.$options.name === "kpi-widget"){
          this.$parent.detailsModal = false;
        }else{
          let kpiModals = this.$parent.kpiWidgetModals;
          for (let i = 0; i < kpiModals.length; i++){
            kpiModals[i].open = false;
          }
          console.log(kpiModals);
        }


      },
      getTimePeriods: function(kpiTimePeriod){
        let timePeriods = ["year", "month", "4weeks", "week", "day"];
        if (typeof kpiTimePeriod !== 'undefined') {
          return timePeriods.slice(0, timePeriods.indexOf(kpiTimePeriod) + 1);
        } else {
          return timePeriods;
        }
      },
      ucFirst: function(text){
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
      setPeriods: function(timeunit) {
        console.log("SetPeriods", timeunit);
        switch (timeunit){
          case "day":
            return {
              start: moment().subtract(1, "week"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "week":
            return {
              start: moment().subtract(2, "month"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "4weeks":
            return {
              start: moment().subtract(1, "year"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "month":
            return {
              start: moment().subtract(1, "year"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
          case "year":
            return {
              start: moment().subtract(5, "year"),
              end: moment(),
              timeunit: timeunit,
              criterium: "loss"
            };
        }
      },
      openModal(id){
        for(let modal of this.kpiWidgetModals){
          if(modal.id === id){
            modal.open = true;
          }
        }
      },
      loadData: function (id) {
        let vm = this;
        let date_range = "";
        console.log(this.performanceRange);
        date_range = "date_start=" + moment(this.performanceRange.start).format("YYYY-MM-DD");
        date_range += "&date_end=" + moment(this.performanceRange.end).format("YYYY-MM-DD");
        date_range += "&time_unit=" + this.performanceRange.timeunit;
        APIHelper
          .getResource("/api/kpi/" + id + "/widget?" + date_range)
          .then(function (data) {
            if (data.kpi.addup_type !== null && data.kpi.addup_type !== false){
              vm.calculatedKpi = true;
            }
            vm.kpiData = data.kpi;
            vm.performanceData = data.performances;
            vm.actionData = data.actions;
            // Generate the icon data
            for (let i = 0; i < vm.actionData.length; i++) {
              vm.actionData[i].icon = vm.actionData[i].status;
            }
            vm.dataLoaded = true;
            vm.problemData = data.problems;
            // Add the expension state
            for (let i = 0; i < vm.problemData.length; i++) {
              vm.problemData[i].expanded = false;
            }
            vm.relatedKPIData = data.dependencies;
            vm.canChangeTarget = data.kpi.can_change_target === 1;
            vm.getProblemsForKpi();
            vm.getPerformanceGraphData();
            vm.getRelatedKpiData();
            vm.cumulative = data.cumulative[Object.keys(data.cumulative)[0]];
            vm.performanceChartData.loaded = true;
            vm.problemChartData.loaded = true;
          });
      },
      date_picked(response){
        if (response !== null) {
          this.performanceRange.start = response.startDate;
          this.performanceRange.end = response.endDate;
          this.performanceChartData.loaded = false;
          this.problemChartData.loaded = false;
          this.loadData(this.kpiId);
        }
      },
      period_changed(){
        this.performanceChartData.loaded = false;
        this.problemChartData.loaded = false;
        this.loadData(this.kpiId);
      },
      getProblemsForKpi: function () {
        let vm = this;
        let barArray = [];
        let lineArray = [];
        let labelsArray = [];
        let i = 0; // keep track of the current array index
        if (this.problemRange.criterium === "loss") {
          for (let problem of vm.problemData) {
            let arrayMax = Math.max.apply(Math, vm.problemData.map((o) => {
              return o.loss;
            }));

            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = arrayMax;

            barArray.push(problem.loss);
            labelsArray.push(problem.name);
            // If it is the first item, push only the loss of this problem, otherwise add it to the previous and push it
            lineArray.push(lineArray[i - 1] === undefined ? (arrayMax * (parseInt(problem.loss_percentage) / 100)) : lineArray[i - 1] + (arrayMax * (parseInt(problem.loss_percentage) / 100)));
            i++;
          }
        } else if (this.problemRange.criterium === "loss_percentage") {
          if (vm.problemData.length > 0) {
            let percentageSum = vm.problemData.reduce((a, b) => {
              return parseInt(a.loss_percentage === undefined ? a : a.loss_percentage) + parseInt(b.loss_percentage)
            });

            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = percentageSum;

            for (let problem of vm.problemData) {
              barArray.push(problem.loss_percentage);
              labelsArray.push(problem.name);
              lineArray.push(lineArray[i - 1] === undefined ? parseInt((parseInt(problem.loss_percentage) / percentageSum) * 100) : parseInt((lineArray[i - 1] + (parseInt(problem.loss_percentage) / percentageSum) * 100)));
              i++;
            }
          }
        } else {
          for (let problem of vm.problemData) {
            let frequencySum = vm.problemData.reduce((a, b) => {
              return parseInt(a.frequency === undefined ? a : a.frequency) + parseInt(b.frequency)
            });
            vm.problemChartData.options.scales.yAxes[1].ticks.suggestedMax = frequencySum;
            barArray.push(problem.frequency);
            labelsArray.push(problem.name);
            // If it is the first item, push only the loss of this problem, otherwise add it to the previous and push it
            lineArray.push(lineArray[i - 1] === undefined ? parseInt(problem.frequency) : lineArray[i - 1] + parseInt(problem.frequency));
            i++;
          }
        }
        vm.problemChartData.dataSets[0].data = barArray;
        vm.problemChartData.dataSets[1].data = lineArray;
        vm.problemChartData.labels = labelsArray;
        vm.problemChartData.loaded = true;
      },
      getPerformanceGraphData(){
        let vm = this;
        vm.performanceChartData.loaded = false;
        // Split the data points for the KPI into the value, shortage and surplus
        let valueArray = [];
        let targetArray = [];
        let colorArray = [];
        let labelsArray = [];
        for(let key in vm.performanceData){
          if (vm.performanceData[key].target || vm.performanceData[key].target === 0) {
            valueArray.push(vm.performanceData[key].performance);
            targetArray.push(vm.performanceData[key].target);

            if (parseInt(vm.performanceData[key].target_met) === 1) {
              colorArray.push("#8cc63e");
            }else{
              colorArray.push("#dc3545");
            }

          }else if(vm.performanceData[key].performance || vm.performanceData[key].performance === 0){
            valueArray.push(vm.performanceData[key].performance);
          }
          labelsArray.push(moment(vm.performanceData[key].date_start).format("MMMM Do"))
        }
        vm.performanceChartData.labels = labelsArray;
        vm.performanceChartData.dataSets[1].data = valueArray;
        vm.performanceChartData.dataSets[0].data = targetArray;
        vm.performanceChartData.dataSets[1].backgroundColor = colorArray;
        vm.performanceChartData.loaded = true;
      },
      getRelatedKpiData(){
        for(let child in this.relatedKPIData){
          this.parseRelatedKpis(this.relatedKPIData[child]);
        }
      },
      iconFormatter: function (value, rowProperties) {
        let icon = "";

        switch (value) {
          case 'done':
            icon = '<i class="ti-check text-success"></i>';
            break;
          case 'accept':
            icon = '<i class="ti-more-alt text-info"></i>';
            break;
          case 'declined':
            icon = '<i class="ti-close text-danger"></i>';
            break;
          case 'pending':
            icon = '<i class="ti-settings text-info"></i>';
            break;
        }

        return icon;
      },

      fetchActionsData: function ({page, filter, sort}) {
        let PAGE_AMOUNT = 5;
        this.actionsPaginationSettings.totalPages = Math.ceil(this.actionData.length / PAGE_AMOUNT);
        this.actionsPaginationSettings.currentPage = page;
        let pageData = this.actionData.slice((page - 1) * PAGE_AMOUNT, page * PAGE_AMOUNT);

        let paginationData = {
          totalPages: this.actionsPaginationSettings.totalPages,
          currentPage: page
        };

        pageData = pageData.sort(this.sortByProperty(sort.fieldName, sort.order));
        return { data: pageData, pagination: paginationData}
      },

      sortByProperty(property, direction) {
        let directionCoeff = direction === "asc" ? 1 : -1;

        return function (a, b) {
          let sortA = (a[property] === null || typeof a[property] === 'undefined') ? a[property] : a[property].toLowerCase();
          let sortB = (b[property] === null || typeof b[property] === 'undefined') ? b[property] : b[property].toLowerCase();

          if (sortA < sortB) {
            return -1 * directionCoeff;
          }

          if (sortA > sortB) {
            return directionCoeff;
          }
          return 0;
        }
      },
    },
    computed: {
      barWidth: {
        // Set the bar width to either 100% or the percentage it should be filled
        get () { return Math.min(( this.kpiData.last_performance.value / this.kpiData.last_performance.target) * 100, 100) },
        set(value){ }
      }
    }
  }
</script>

<style>
  .time-period-select{
    background-color: white;
    color: black;
  }

  button.close-button {
    margin-top: 10px !important;
  }

  .daterangepicker :not(.weekend){
    color: initial;
  }
  /* Css hack to hide the filter functionality */
  .actions-table input {
    display: none;
  }
  .tab-content{
    padding-left: 22px !important;
    padding-bottom: 10px;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }
  .modal-mask > *{
    display: flex;
  }

  .modal-wrapper {
    display: table-cell;
  }

  .modal-content{
    overflow-y: auto;
    overflow-x: visible;
    min-height: 550px;
  }
  /*@media( min-width: 1000px){*/
  /*.modal-dialog {*/
  /*max-width: 1500px;*/
  /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/KpiDetailsModal.vue